import { FullscreenModal } from '@/components/global'
import { Button, Input } from '@/components/priority'
import Flex from '@/components/priority/Flex/Flex'
import Text from '@/components/priority/Text/Text'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

type ServiceTemplateCreateModalProps = {
  show: boolean
  setShow: (show: boolean) => void
  templateName: string
  setTemplateName: (templateName: string) => void
  onCreateTemplate: () => void
}
const ServiceTemplateCreateModal = ({
  show,
  setShow,
  templateName,
  setTemplateName,
  onCreateTemplate,
}: ServiceTemplateCreateModalProps) => {
  const { t } = useTranslation()

  return createPortal(
    <FullscreenModal show={[show, () => setShow(false)]} hideClose={false}>
      <Flex column full padding="32px" maxWidth="600px">
        <Text size="20px" weight="600" margin="10px 0 10px 0">
          {t(
            'editor.serviceTemplates.convertToServiceInformationTemplateTitle',
          )}
        </Text>
        <Text size="16px" margin="10px 0 10px 0">
          {t(
            'editor.serviceTemplates.convertToServiceInformationTemplateDescription',
          )}
        </Text>
        <Input
          // @ts-expect-error - Input component value prop not properly typed
          value={[templateName, setTemplateName]}
          label={t('editor.serviceTemplates.templateNameLabel')}
          data-testid="editor-service-template-name-input"
        />
        <Flex justify="flex-end" margin="10px 0 0 0" gap="12px">
          <Button onClick={() => setShow(false)}>
            {t('editor.serviceTemplates.cancelButton')}
          </Button>
          <Button primary onClick={onCreateTemplate}>
            {t('editor.serviceTemplates.createTemplateButton')}
          </Button>
        </Flex>
      </Flex>
    </FullscreenModal>,
    document.body,
  )
}

export default ServiceTemplateCreateModal
